<template>
  <v-window>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar class="secondary" flat card dense>
          <v-toolbar-title class="white--text">
            {{ $t(activeSection) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-form
        ref="form"
        v-model="valid"
        md-6
        v-on:submit.prevent="
          () => {
            return false;
          }
        "
        offset-3
      >
        <v-card-text>
          <v-text-field
            :label="$t('global.placeholder.username')"
            v-model="username"
            name="username"
            :rules="usernameRules"
            type="email"
            required
          >
          </v-text-field>

          <v-text-field
            :label="$t('global.placeholder.password')"
            v-model="password"
            name="password"
            :rules="passwordRules"
            :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
            @click:append="() => (hidePassword = !hidePassword)"
            :type="hidePassword ? 'text' : 'password'"
            required
          >
          </v-text-field>

          <a
            @click="goToForgotPassword"
            class="ml-2"
            v-html="$t('login.button.reset')"
          ></a>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn
            to="/"
            round
            flat
            color="primary"
            :disabled="isLoading"
            class="capitalize"
          >
            {{ $t('global.button.cancel') }}
          </v-btn>

          <v-btn
            :disabled="!valid"
            :loading="isLoading"
            color="accent"
            class="capitalize"
            type="submit"
            @click="submit"
            round
            outline
          >
            {{ $t('global.button.login') }}
          </v-btn>
        </v-card-actions>

        <v-card-actions v-if="!isChile" class="py-4 grey lighten-4 mt-5">
          <v-spacer></v-spacer>
          <span class="grey--text text--darken-2">{{
            $t('login.label.register')
          }}</span>
          <v-btn
            :to="$t('urlRegister')"
            class="ml-3 initialize"
            color="primary"
            round
            outline
            v-html="$t('login.button.register')"
          ></v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-window>
</template>

<script>
import authService from '@/services/authService';
import keys from '@/store/keys';
import store from '@/store/';
import { EventBus } from '@/services/eventBus';
import userService from '@/services/userService';
import utilService from '@/services/utilService';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import manageErrorService from '@/services/manageErrorService';

export default {
  name: 'Login',
  computed: {
    activeSection() {
      return store.state.activeSection;
    },
    // Chile: servicio cerrado, no se ofrece registro de nuevos usuarios.
    isChile() {
      return utilService.isChile();
    },
    usernameRules() {
      return [
        (v) => !!v || this.$i18n.t('global.validation.required.text'),
        (v) =>
          /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          this.$i18n.t('global.validation.email.format'),
      ];
    },
    passwordRules() {
      return [
        (v) => !!v || this.$i18n.t('global.validation.required.text'),
        (v) => v.length <= 50 || this.$i18n.t('global.validation.maximum.50'),
      ];
    },
    notFinishedRegister() {
      return userService.noActivated() || userService.sentLetter();
    },
    registeredWithBle() {
      return userService.registeredWithBle();
    },
  },
  data() {
    return {
      password: '',
      username: '',
      isLoading: false,
      valid: false,
      hidePassword: false,
    };
  },
  created() {
    store.commit('FORGOT_USER');
  },
  methods: {
    async submit() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }
      let params = {
        username: this.username,
        password: this.password,
      };
      this.isLoading = true;
      let resp = await authService.login(params);

      if (resp.error) {
        if (resp.data === 401) {
          EventBus.$emit(keys.eventOnShowNotification, {
            message: this.$i18n.t('login.error.401'),
            type: 'error',
            doNotTranslate: true,
          });
          this.isLoading = false;
          return;
        }

        manageErrorService.handle(resp.data);
        this.isLoading = false;
        return;
      }

      if (resp.data.customToken !== null) {
        await firebase.auth().signInWithCustomToken(resp.data.customToken);
      }

      this.isLoading = false;

      this.$mam.login();

      if (this.notFinishedRegister) {
        if (this.registeredWithBle) {
          this.$router.push({ path: this.$i18n.t('urlValidationWait') });
        } else {
          this.$router.push({ path: this.$i18n.t('urlTeletac') });
        }
      } else {
        if (store.state.goToRouteAfterLogin !== null) {
          let path = store.state.goToRouteAfterLogin.fullPath;
          store.commit('UPDATE_GO_TO_ROUTE_AFTER_LOGIN', { to: null });
          this.$router.push({ path: path });
        } else {
          this.$router.push({ path: this.$i18n.t('urlUser') });
        }
      }

      return true;
    },

    goToForgotPassword() {
      store.commit('FORGOT_USER', { username: this.username });
      this.$router.push({ path: this.$i18n.t('urlForgotPassword') });
    },
  },
};
</script>
